import {
  PencilSquareIcon,
  HomeIcon,
  FolderIcon,
  BookOpenIcon,
  BuildingStorefrontIcon
} from "@heroicons/react/24/outline";
import TopNavigation from "../navigation/TopNavigation";
import { getAllowedCampaignTypes, useCurrentUser } from "../../utils/CurrentUserContext";
import { useAuth0 } from "@auth0/auth0-react";
import { CompanyType } from "../../__generated__/graphql";

const filterHidden = ({hidden}) => !hidden
export default function Layout(props) {
  const {user} = useCurrentUser();
  const {nativeContent, nativeDisplay} = getAllowedCampaignTypes(user)

  const hideCreateNativeContent = nativeContent.length === 0
  const hideCreateNativeDisplay = nativeDisplay.length === 0
  const hideCreateCampaigns = hideCreateNativeContent && hideCreateNativeDisplay

  const { logout } = useAuth0();
  
  const navigation = [
    {
      name: "Home",
      to: "/",
      end: true,
      Icon: HomeIcon,
    },
    {
      name: "Campaigns",
      to: "/campaigns",
      Icon: FolderIcon,
    },

    {
      name: "Marketplace",
      to: "/marketplace-campaigns",
      Icon: BuildingStorefrontIcon,
      hidden: user?.company?.type !== CompanyType.Publisher,
      // hidden: true,
    },
    {
      name: 'Content Library',
      Icon: BookOpenIcon,
      hidden: !user?.company?.allowVevIntegration,
      children: [
        {
          name: 'Article templates',
          to: '/library/article-templates',
        }
      ]
    },
    {
      name: "New Campaign",
      hidden: hideCreateCampaigns,
      children: [
        {
          name: "Native Content",
          to: `/create/campaign`,
          hidden: hideCreateNativeContent,
        },
        {
          name: "Native Display",
          to: `/create/display-campaign`,
          hidden: hideCreateNativeDisplay,
        },
      ].filter(filterHidden),
      Icon: PencilSquareIcon,
    },
  ].filter(filterHidden);

  const userNavigation = [
    { name: "Profile", to: "/settings/profile" },
    { name: "Account", to: "/settings/account" },
    { name: "Sign out", onClick: () => logout({ returnTo: window.location.origin }) },
  ];

  return (
    <div className="h-full bg-gray-100">
      <div className="min-h-full">
        {/* When the mobile menu is open, add `overflow-hidden` to the `body` element to prevent double scrollbars */}
        <TopNavigation
          user={user}
          userNavigation={userNavigation}
          navigation={navigation}
        />
        <div className="pt-10">
          <div className="mx-auto sm:px-6 lg:max-w-8xl">
            <main className="mx-auto sm:px-6 lg:max-w-7xl lg:px-8">
              {props.children}
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
